<template>
  <div style="min-width: 1200px; height: 100%; background: white;">
    <div class="header">
      <div>
        <img class="header-wrap-img" src="../../assets/img/logo1.png">
        <img class="header-wrap-img2" src="../../assets/img/logo2.png">
      </div>
      <div class="header-wrap-right">
        <div class="header-wrap-right-item header-wrap-right-item-border">官网首页</div>
        <div class="header-wrap-right-item" @click='clickNum(1)'>项目概况</div>
        <!--        <div class="header-wrap-right-item" @click='clickNum(2)'>项目团队</div>-->
        <div class="header-wrap-right-item" @click='clickNum(2)'>适用对象</div>
        <div class="header-wrap-right-item" @click='clickNum(3)'>项目视频</div>
        <div class="header-wrap-right-item" @click='clickNum(4)'>联系我们</div>
      </div>
    </div>
    <div class="awe-content">
      <div class="hero"  >
        <div class="awe-overlay"></div>
        <div class="hero__wrapper" v-loading="loading"
             element-loading-text="载入中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="hero__wrapper__title">口腔检查虚拟仿真实验考教系统</div>
          <div class="hero__wrapper__text">
            <a href="http://kqyxy.xjmu.edu.cn/">南京大学医学院口腔医学院</a>
          </div>
          <div class="hero__wrapper__text">
            <div>
              <img style="width: 300px;margin-top: 60px;" src="../../assets/img/jump.jpg" alt="">
            </div>
            <div  class="hero__wrapper__text" style="margin-top: 20px;font-size: 15px;cursor: pointer;">
              <el-button  type="primary"  @click="jugeTicket"> 虚拟仿真系统学生入口</el-button>
            </div>
            <div v-if="!ticket"  class="hero__wrapper__text" style="margin-top: 20px;font-size: 15px;cursor: pointer;">
              <el-button  @click="jugeTicket2" type="success">虚拟仿真系统评审入口</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="awe-section">
        <div class="awe-section__content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;利用虚拟仿真技术及多媒体的图、文、声、像技术结合，学生通过线上和线下理论学习，结合虚拟仿真操作实训双重学习，提高学生学习的积极性和主动性，掌握口腔医学生临床操作技能和思维，缩短临床实习的适应期。</div>
      </div>
      <div class="awe-section-wrap" id="t1">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="awe-section-wrap-title">项目概况</div>
          <div class="awe-section-wrap-content">
            <img class="awe-section-wrap-content-left" src="../../assets/img/case41.png">
            <div class="awe-section-wrap-content-right">
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;利用虚拟仿真技术构建标准化口腔病人，训练及考察学生理论知识掌握、病史资料采集、基本检查操作技能、综合临床思维能力，并适当熏陶其医患沟通能力、人文关怀素质等，从而为医学生进入临床实践打下坚实的基础。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1、通过对虚拟仿真标准化病人的口腔检查，帮助学生理解和掌握口腔检查的完整环节和口腔前准备、基本检查的具体内容和注意事项。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                2、通过自主学习和互动反馈，使学生能够根据不同临床情景进行规范和正确的口腔检查，掌握对不同情况患者进行以诊断为导向的口腔检查的能力。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、通过具体化、标准化的训练要求，加强学生口腔检查的思维逻辑，实现教学和考核的标准化</p>
            </div>
          </div>
        </div>
      </div>
      <div class="awe-section-wrap" style="padding: 0;">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="filter__list">
            <el-button type="primary" :disabled="show" style="margin-right: 10px;" @click="showPic(0)">全部图片</el-button>
            <el-button type="primary" :disabled="show1" style="margin-right: 10px;" @click="showPic(1)">准备</el-button>
            <el-button type="primary" :disabled="show2" style="margin-right: 10px;" @click="showPic(2)">操作</el-button>
            <el-button type="primary" :disabled="show3" @click="showPic(3)">练习</el-button>
          </div>
          <div class="awe-section-wrap-List" style="display: inline" >
            <transition name="el-zoom-in-center">
              <div v-show="show||show1" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case1.png')"
                          :preview-src-list="[require('../../assets/img/case1.png')]"></el-image>
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show||show1" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case2.png')"
                          :preview-src-list="[require('../../assets/img/case2.png')]"></el-image>
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show||show2" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case3.png')"
                          :preview-src-list="[require('../../assets/img/case3.png')]"></el-image>
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show||show2" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case4.png')"
                          :preview-src-list="[require('../../assets/img/case4.png')]"></el-image>
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show||show3" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case5.png')"
                          :preview-src-list="[require('../../assets/img/case5.png')]"></el-image>
              </div>
            </transition>
            <transition name="el-zoom-in-center">
              <div v-show="show||show3" class="transition-box">
                <el-image class="awe-section-wrap-List-img" :src="require('../../assets/img/case6.png')"
                          :preview-src-list="[require('../../assets/img/case6.png')]"></el-image>
              </div>
            </transition>

          </div>
        </div>
      </div>
      <!--      <div class="awe-section-wrap">-->
      <!--        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">-->
      <!--          <div class="awe-section-wrap-title">项目团队</div>-->
      <!--          <div class="awe-section-wrap-List">-->
      <!--            <div class="awe-section-wrap-List-item">-->
      <!--              <img class="awe-section-wrap-List-item-img" src="../../assets/img/td1.png"/>-->
      <!--              <div class="awe-section-wrap-List-item-title">团队负责人</div>-->
      <!--              <div class="awe-section-wrap-List-item-name">赵今（教授）</div>-->
      <!--            </div>-->
      <!--            <div class="awe-section-wrap-List-item">-->
      <!--              <img class="awe-section-wrap-List-item-img" src="../../assets/img/td2.png"/>-->
      <!--              <div class="awe-section-wrap-List-item-title">团队主要成员</div>-->
      <!--              <div class="awe-section-wrap-List-item-name">郭全民（高级实验师）顾敏（高级实验师）</div>-->
      <!--            </div>-->
      <!--            <div class="awe-section-wrap-List-item">-->
      <!--              <img class="awe-section-wrap-List-item-img" src="../../assets/img/td3.png"/>-->
      <!--              <div class="awe-section-wrap-List-item-title">团队其他成员</div>-->
      <!--              <div class="awe-section-wrap-List-item-name">陈玉根（专职教务）赛格林（科长）曹锐（工程师）吴立平（工程师）</div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="awe-section-wrap" id="t2">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="awe-section-wrap-title">适用对象</div>
          <div class="awe-section-wrap-bg">
            <div class="awe-overlay"></div>
            <div class="awe-section-wrap-bg-List">
              <div class="awe-section-wrap-bg-List-item">
                <div class="awe-section-wrap-bg-List-item-num"> </div>
                <div class="awe-section-wrap-bg-List-item-occupation">本科生</div>
              </div>
              <div class="awe-section-wrap-bg-List-item">
                <div class="awe-section-wrap-bg-List-item-num"> </div>
                <div class="awe-section-wrap-bg-List-item-occupation">研究生</div>
              </div>
              <div class="awe-section-wrap-bg-List-item">
                <div class="awe-section-wrap-bg-List-item-num"> </div>
                <div class="awe-section-wrap-bg-List-item-occupation">规培生</div>
              </div>
              <div class="awe-section-wrap-bg-List-item">
                <div class="awe-section-wrap-bg-List-item-num"> </div>
                <div class="awe-section-wrap-bg-List-item-occupation">教师</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="awe-section-wrap" id="t3">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="awe-section-wrap-title" style="margin-bottom: 0;">项目简介视频</div>
          <div class="awe-section-wrap-describe">为了辅助学习《口腔检查虚拟仿真实验考教系统》，项目组录制了短视频以供参考。</div>
          <video src="https://unidraw.oss-cn-huhehaote.aliyuncs.com/uploads/videos/%E9%A1%B9%E7%9B%AE%E7%AE%80%E4%BB%8B%E8%A7%86%E9%A2%91.mp4" style="width: 100%; height: 100%; display: block;"
                 controls="controls" muted="muted" loop type="video/mp4"></video>
        </div>
      </div>
      <div class="awe-section-wrap">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="awe-section-wrap-title">教学引导视频</div>
          <video src="https://unidraw.oss-cn-huhehaote.aliyuncs.com/uploads/videos/%E9%A1%B9%E7%9B%AE%E5%BC%95%E5%AF%BC%E8%A7%86%E9%A2%91.mp4" style="width: 100%; height: 100%; display: block;"
                 controls="controls" muted="muted" loop type="video/mp4"></video>
        </div>
      </div>
      <div class="awe-section-wrap" id="t4">
        <div style="width: 1200px; margin: 0 auto; display: flex; flex-direction: column; align-items: center;">
          <div class="awe-section-wrap-title">联系我们</div>
          <div class="awe-section-wrap-List">
            <div class="awe-section-wrap-List-item">
              <img class="awe-section-wrap-List-item-img" src="../../assets/img/dz.png"/>
              <div class="awe-section-wrap-List-item-title2">通讯地址</div>
              <div class="awe-section-wrap-List-item-address">南京市玄武区中央路30号</div>
            </div>
            <div class="awe-section-wrap-List-item">
              <img class="awe-section-wrap-List-item-img" src="../../assets/img/yx.png"/>
              <div class="awe-section-wrap-List-item-title2">E-mail</div>
              <div class="awe-section-wrap-List-item-address">njkqjyk@163.com</div>
            </div>
            <div class="awe-section-wrap-List-item">
              <img class="awe-section-wrap-List-item-img" src="../../assets/img/dh.png"/>
              <div class="awe-section-wrap-List-item-title2">电话</div>
              <div class="awe-section-wrap-List-item-address">025-83620361</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer__wrapper">版权所有：南京大学医学院口腔医学院</div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>非法访问！请从<a href='http://jsxngx.seu.edu.cn/ResourceDetail.aspx?Id=687'>江苏省高等学校虚拟仿真实验教学共享平台</a>访问</span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      dialogVisible: false,
      show: true,
      loading: false,
      code: '',
      ticket: this.$route.query.ticket?this.$route.query.ticket:'',
    }
  },
  components: {},
  methods: {
    jugeTicket(){
      const baseurl = this.GLOBAL.BASE_URL;
      console.log(baseurl)
      const url='http://www.unidraw.com/webgl/OralExamination'
      const params= this.$route.query;
      if(!params.ticket)
      {
        this.dialogVisible=true
      }else
      {
        this.loading=true
        this.$http.otherJsxngx(params).then(res=>{
          if (res.code==200)
          {
            this.$http
              .getsjCode({user_id:res.data.user_id})
              .then(rs => {
                if (rs.code == 200) {
                  this.loading=false
                  parent.location.href =
                    url +
                    "?user_id=" +
                    res.data.user_id +
                    "+" +
                    baseurl+"+"+rs.data+"+"+51;
                } else {
                  this.$message.error(rs.message);
                }
              });
          }else {
            this.$message.error(res.message);
          }
        })
      }
    },
    jugeTicket2(){
      const baseurl = this.GLOBAL.BASE_URL;
      console.log(baseurl)
      const url='http://www.unidraw.com/webgl/OralExamination'
      this.$http
        .getsjCode({user_id:2890})
        .then(rs => {
          if (rs.code == 200) {
            this.loading=false
            parent.location.href =
              url +
              "?user_id=" +
              2890 +
              "+" +
              baseurl+"+"+rs.data+"+"+51;
          } else {
            this.$message.error(rs.message);
          }
        });
    },
    clickNum(id) {
      document.querySelector('#t' + id).scrollIntoView()
    },
    showPic(number)
    {
      if (number==1)
      {
        this.show=false
        this.show1=true
        this.show2=false
        this.show3=false
      }
      else if (number==2)
      {
        this.show=false
        this.show1=false
        this.show2=true
        this.show3=false
      }
      else if (number==3)
      {
        this.show=false
        this.show1=false
        this.show2=false
        this.show3=true
      }
      else{
        this.show=true
        this.show1=false
        this.show2=false
        this.show3=false
      }
    }
  }
}
</script>

<style lang="less" scoped>

.portfolio__inner {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  margin: auto;
}
.transition-box{
  float: left;
  width: 33%;
}
.header {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;

  .header-wrap-img {
    width: 130px;
    height: 150px;
  }

  .header-wrap-img2 {
    width: 180px;
    height: 170px;
  }

  .header-wrap-right {
    display: flex;
    align-items: center;

    .header-wrap-right-item {
      cursor: pointer;
      font-size: 15px;
      color: #000000;
      font-weight: 600;
      text-transform: uppercase;
      padding: 20px 5px 10px 5px;
      margin-left: 45px;
    }

    .header-wrap-right-item-border {
      border-bottom: solid 2px #e6212a;
    }
  }
}

.awe-content {
  .hero {
    height: 100vh;
    background-image: url('https://unidraw.oss-cn-huhehaote.aliyuncs.com/banner.png');
    position: relative;

    .hero__wrapper {
      position: absolute;
      top: 350px;
      left: 0;
      z-index: 2;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      .hero__wrapper__title {
        font-size: 50px;
        font-weight: 400;
        color: #fff;
        margin-top: 0;
        margin-bottom: 25px;
      }

      .hero__wrapper__text {
        color: #eee;
        font-size: 30px;
        font-weight: 400;

        a {
          margin-left: 20px;
          color: #008fff;
          text-decoration: none;
        }
      }

      .hero__wrapper__button {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-top: 30px;
      }
    }
  }

  .awe-section {
    background: #f7f7f7;
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex;
    align-items: center;
    justify-content: center;

    .awe-section__content {
      width: 66.66666667%;
      font-size: 22px;
      color: #748182;
      line-height: 2.1;
    }
  }

  .awe-section-wrap {
    background: white;
    padding-top: 100px;
    padding-bottom: 100px;

    .awe-section-wrap-title {
      font-weight: 400;
      font-size: 40px;
      color: #333;
      margin-bottom: 40px;
    }

    .awe-section-wrap-content {
      width: 100%;
      display: flex;
      align-items: flex-start;
      line-height: 2.1;
      font-size: 14px;
      font-weight: 400;
      color: #748182;

      .awe-section-wrap-content-left, .awe-section-wrap-content-right {
        padding-left: 15px;
        padding-right: 15px;
        width: 50%;

        p {
          margin-bottom: 16px;
          font-family: "Montserrat", sans-serif;
          font-weight: 400;
        }
      }
    }

    .filter__list {
      display: flex;
      align-items: center;
    }

    .awe-section-wrap-List {
      display:flex;height: 100%;margin-top: 30px;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;

      .awe-section-wrap-List-img {
        width: 95%;
        margin-bottom: 5px;
      }

      .awe-section-wrap-List-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 33%;

        .awe-section-wrap-List-item-img {
          width: 120px;
        }

        .awe-section-wrap-List-item-title {
          font-size: 22px;
          font-weight: 600;
          margin-top: 30px;
          margin-bottom: 15px;
        }
        .awe-section-wrap-List-item-name {
          color: #555;
          font-size: 15px;
          line-height: 25px;
          text-align: center;
        }

        .awe-section-wrap-List-item-title2 {
          font-size: 22px;
          color: #333;
          margin-top: 0;
          margin-bottom: 5px;
        }

        .awe-section-wrap-List-item-address {
          color: #008fff;
          font-size: 14px;
          line-height: 2.1;
          text-align: center;
        }
      }
    }

    .awe-section-wrap-bg {
      width: 100%;
      height: 335px;
      position: relative;
      background-image: url(../../assets/img/bg.jpg);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;

      .awe-section-wrap-bg-List {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 2;
        width: 100%;
        transform: translateY(-50%);
        text-align: center;
        display: flex;
        align-items: center;

        .awe-section-wrap-bg-List-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .awe-section-wrap-bg-List-item-num {
            color: #008fff;
            font-size: 60px;
            font-weight: bold;
            margin-top: 10px;
            line-height: normal;
            display: block;
          }

          .awe-section-wrap-bg-List-item-occupation {
            color: #fff;
            margin-top: 10px;
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
    }

    .awe-section-wrap-describe {
      text-align: center;
      margin: 10px 25% 60px 25%;
      word-spacing: 2px;
      color: #555;
      font-size: 15px;
    }
  }
}

.awe-overlay {
  background-color: rgba(0, 0, 0, .4);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.footer {
  padding: 70px 0;
  position: relative;
  background-color: #008fff;
  color: #fff;
  text-align: center;

  .footer__wrapper {
    color: white;
    line-height: 2.1;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/njkq/index.vue